module.exports = __webpack_public_path__ + "static/media/53.a1925487.mp3";